import { Collapse, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { FileUploader, IconButton, Resource } from 'utoniq-ui'

import { ItemType } from '@/clients/utoniq-core/schema'
import {
  CreateItemProps,
  FileUploadInfo,
} from '@/components/pages/ConsoleItemCreate/template/ItemCreateForm'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type ContentsAudioInputCellProps = {
  resourceType: ItemType.Avatar | ItemType.Wallpaper
  watch: UseFormWatch<CreateItemProps>
  audioUploadInfo: FileUploadInfo
  setValue: UseFormSetValue<CreateItemProps>
  onClose?: () => void
  /** ドキュメント作成時にartist.resourceドキュメントを作るかどうか、resourceまたはwallpaperResourceをcreateする際はtrueにする */
  hasCreateResource: boolean
}
export const ContentsAudioInputCell: Cell<ContentsAudioInputCellProps> = ({
  resourceType,
  audioUploadInfo,
  setValue,
  watch,
  onClose,
  hasCreateResource,
}) => {
  const [expanded, setExpanded] = useState<boolean>(false)
  const { t } = useTranslation('consoleItemCreate')
  return (
    <CellFrame sx={{ pb: 8 }}>
      <Stack direction="row" alignItems="center" sx={{ pt: 4 }}>
        <Typography variant="h6">{t('contentAudioLabel')}</Typography>
        <Typography variant="subtitle1" color="text.hint">
          {t('optional')}
        </Typography>
        {expanded ? (
          <IconButton.UpArrow
            size="medium"
            onClick={() => setExpanded(prevState => !prevState)}
            bgcolor="transparent"
          />
        ) : (
          <IconButton.DownArrow
            size="medium"
            onClick={() => setExpanded(prevState => !prevState)}
            bgcolor="transparent"
          />
        )}
      </Stack>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <FileUploader
          t={t}
          sx={{ p: 0 }}
          resource={watch('resource') as Resource | undefined}
          fileUploadInfo={{
            type: 'audio',
            onDrop() {
              return audioUploadInfo
                .onDrop(ItemType.Audio, hasCreateResource)
                .then(async resource => {
                  if (!resource) {
                    return
                  }
                  if (resourceType === ItemType.Wallpaper) {
                    setValue(
                      'wallpaperResources.audioResourceId',
                      resource.id as never
                    )
                  } else {
                    setValue(
                      'avatarResources.voiceResourceId',
                      resource.id as never
                    )
                  }
                  setValue('resource', resource)
                  return resource
                })
            },
            progress: audioUploadInfo.progress || 0,
            description: t('audioUploaderDescription'),
            onClose() {
              if (resourceType === ItemType.Wallpaper) {
                setValue('wallpaperResources.audioResourceId', '' as never)
              } else {
                setValue('avatarResources.voiceResourceId', '' as never)
              }
              setValue('resource', null)
              onClose && onClose()
            },
          }}
          content={{ title: '' }}
        />
      </Collapse>
    </CellFrame>
  )
}
